import { z } from 'zod'

export const bugReportSchema = z.object({
  contactPerson: z.string().min(1, 'Pflichtfeld'),
  email: z.string().min(1, 'Pflichtfeld').email('Ungültige E-Mail-Adresse'),
  phoneNumber: z.string().optional(),
  service: z.string().min(1, 'Pflichtfeld'),
  priority: z.enum(['low', 'normal', 'high', 'urgent'], {
    message: 'Pflichtfeld'
  }),
  observedBehavior: z.string().min(1, 'Pflichtfeld'),
  expectedBehavior: z.string().optional(),
  stepsToReproduce: z.string().min(1, 'Pflichtfeld'),
  startTime: z.string().min(1, 'Pflichtfeld'),
  additionalContext: z.string().optional(),
  description: z.string().optional()
})

export const featureReportSchema = z.object({
  contactPerson: z.string().min(1, 'Pflichtfeld'),
  email: z.string().min(1, 'Pflichtfeld').email('Ungültige E-Mail-Adresse'),
  phoneNumber: z.string().optional(),
  service: z.string().min(1, 'Pflichtfeld'),
  priority: z.enum(['low', 'normal', 'high', 'urgent'], {
    message: 'Pflichtfeld'
  }),
  businessContext: z.string().min(1, 'Pflichtfeld'),
  expectedBenefit: z.string().min(1, 'Pflichtfeld'),
  proposedSolution: z.string().optional(),
  description: z.string().optional()
})

export const emergencyReportSchema = z.object({
  contactPerson: z.string().min(1, 'Pflichtfeld'),
  email: z.string().min(1, 'Pflichtfeld').email('Ungültige E-Mail-Adresse'),
  phoneNumber: z.string().min(1, 'Pflichtfeld'),
  service: z.string().min(1, 'Pflichtfeld'),
  priority: z.enum(['low', 'normal', 'high', 'urgent']).optional(),
  description: z.string().min(1, 'Pflichtfeld'),
  businessImpact: z.string().min(1, 'Pflichtfeld'),
  startTime: z.string().min(1, 'Pflichtfeld'),
  dataLoss: z.boolean().optional(),
  securityImpact: z.boolean().optional(),
  productionOutage: z.boolean().optional(),
  venaboTicket: z.string().optional()
})

export const bugSteps = [
  ['contactPerson', 'email', 'phoneNumber', 'service', 'priority'],
  ['observedBehavior', 'expectedBehavior', 'stepsToReproduce', 'startTime', 'additionalContext'],
  []
] as const

export const featureSteps = [
  ['contactPerson', 'email', 'phoneNumber', 'service', 'priority'],
  ['businessContext', 'expectedBenefit', 'proposedSolution'],
  []
] as const

export const emergencySteps = [
  ['contactPerson', 'email', 'phoneNumber', 'service'],
  ['description', 'businessImpact', 'startTime', 'dataLoss', 'securityImpact', 'productionOutage', 'venaboTicket'],
  []
] as const

export type BugReportSchema = z.infer<typeof bugReportSchema>
export type FeatureReportSchema = z.infer<typeof featureReportSchema>
export type EmergencyReportSchema = z.infer<typeof emergencyReportSchema>
